import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["toggle", "input"]
  }

  connect() {
    this.setToggleState()
  }

  update() {
    this.setToggleState()

    if (!this.hasLimits()) {
      this.toggleTarget.checked = false
    }
  }

  hasLimits() {
    return this.inputTargets.find((input) => parseInt(input.value) > 0) || false
  }

  setToggleState() {
    this.toggleTarget.disabled = !this.hasLimits()
  }
}
